import { RuleGroup } from './RuleGroup'
import { RulePreview } from './RulePreview'
import type { PredicateNode, RuleBuilderProps } from './types'

export function RuleBuilder({ metadata, value, onChange }: RuleBuilderProps) {
  // Top-level always rendered as group; if input is condition or true, wrap.
  const root: Extract<PredicateNode, { type: 'group' }> =
    value.type === 'group'
      ? value
      : { type: 'group', connector: 'and', children: [value] }

  return (
    <div className="flex flex-col gap-2 text-sm">
      <RuleGroup
        metadata={metadata}
        node={root}
        onChange={onChange}
      />
      <div>
        <span className="text-[10px] uppercase text-slate-500">Podgląd</span>
        <RulePreview value={root} />
      </div>
    </div>
  )
}
